export default {"src":"/_next/static/media/finish-quickly.dfa8d92b.svg","height":33,"width":33,"blurWidth":0,"blurHeight":0};